import React from 'react'

export default (props: any) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_1_3" fill="white">
      <path d="M7.02095 2.04546C5.7629 2.04546 4.53311 2.41851 3.48708 3.11744C2.44105 3.81637 1.62578 4.80979 1.14434 5.97208C0.66291 7.13436 0.536945 8.4133 0.782377 9.64717C1.02781 10.881 1.63362 12.0144 2.52319 12.904C3.41276 13.7936 4.54615 14.3994 5.78002 14.6448C7.01389 14.8902 8.29283 14.7643 9.45512 14.2828C10.6174 13.8014 11.6108 12.9861 12.3097 11.9401C13.0087 10.8941 13.3817 9.66429 13.3817 8.40625L7.02095 8.40625L7.02095 2.04546Z" />
    </mask>
    <path
      d="M7.02095 2.04546C5.7629 2.04546 4.53311 2.41851 3.48708 3.11744C2.44105 3.81637 1.62578 4.80979 1.14434 5.97208C0.66291 7.13436 0.536945 8.4133 0.782377 9.64717C1.02781 10.881 1.63362 12.0144 2.52319 12.904C3.41276 13.7936 4.54615 14.3994 5.78002 14.6448C7.01389 14.8902 8.29283 14.7643 9.45512 14.2828C10.6174 13.8014 11.6108 12.9861 12.3097 11.9401C13.0087 10.8941 13.3817 9.66429 13.3817 8.40625L7.02095 8.40625L7.02095 2.04546Z"
      stroke="#CBCBCB"
      strokeWidth="2"
      mask="url(#path-1-inside-1_1_3)"
    />
    <path
      d="M5.69576 9.38013V3.02671H7.04293V8.26763H9.61993V9.38013H5.69576ZM12.7054 5.64282L14.0308 3.02671H15.4823L13.3746 6.90742V9.38013H12.0361V6.95088L9.92848 3.02671H11.3886L12.7054 5.64282Z"
      fill="#4F4F4F"
    />
  </svg>
)
